import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTheme } from '@material-ui/core/styles';
import { useSidebarStyles } from './styles';
import JString from '@easytech-international-sdn-bhd/jstring';

const SidebarHeader = ({ logoUrl, companyName, gState, onCollapse, drawerOpen }) => {
	const classes = useSidebarStyles();
	const theme = useTheme();

	const resolvedName = companyName
		? companyName
		: JString(gState.client).toUpperCase() + (
			gState.company ? ` | ${JSON.parse(gState.company.toUpperCase()).join(', ')}` : ''
		);

	return (
		<div className={classes.header}>
			<div className={classes.headerLogoWrap}>
				{logoUrl ? (
					<>
						<img className={classes.headerLogoImg} src={logoUrl} alt="logo" />
						{drawerOpen && (
							<h1 className={classes.headerCompany}>{resolvedName}</h1>
						)}
					</>
				) : (
					drawerOpen && (
						<h1 className={classes.headerCompanyNoLogo}>{resolvedName}</h1>
					)
				)}
			</div>
			{drawerOpen && (
				<IconButton onClick={onCollapse} className={classes.headerToggle} size="small">
					{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
				</IconButton>
			)}
		</div>
	);
};

export default SidebarHeader;
